import { PatternValidatorConfig, ValdrValidator } from '@app/valdr/models';
import { hasNoValue } from '@app/valdr/util';

const REGEXP_PATTERN = /^\/(.*)\/([gim]*)$/;

const asRegExp = function (pattern) {
  if (pattern.test) {
    return pattern;
  } else {
    const match = pattern.match(REGEXP_PATTERN);
    if (match) {
      return new RegExp(match[1], match[2]);
    } else {
      throw new Error(`Expected ${pattern} to be a RegExp`);
    }
  }
};

export const patternValidator: ValdrValidator = ({value: patternString}: PatternValidatorConfig, value) => {
  const pattern = asRegExp(patternString);
  return hasNoValue(value) || pattern.test(value);
};
